export default {"src":"/_next/static/media/gaming-icon.bdf73b40.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};